import axios, { type AxiosRequestConfig } from "axios";
import {
  createApiHeaders,
  setAxiosInstance,
  updateAxiosHeaders,
} from "common-frontend/src/network/axios";
import config from "./config";
import i18n from "./i18n";
import refreshInterceptor from "./interceptors/refreshInterceptor";

const axiosConfig: AxiosRequestConfig = {
  baseURL: config.API_LOCAL_NETWORK
    ? `http://${window.location.hostname}:3000`
    : config.API_BASE_URL,
  withCredentials: true,
  headers: createApiHeaders("web", i18n.language),
};

const axiosServices = axios.create(axiosConfig);

// interceptor for http
axiosServices.interceptors.response.use(
  (response) => response,
  refreshInterceptor,
);

setAxiosInstance(axiosServices as any);

i18n.on("languageChanged", () => {
  updateAxiosHeaders("web", i18n.language);
});

export default axiosServices;
